import React, { useState } from 'react';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import PaymentsAPI from 'api/PaymentsAPI';
import { useSnackbar } from 'notistack';

interface IFormProps {
  setCreateMode: any;
  paymentSubmit?: string;
  setPaymentSubmit?: any;
}

const PaymentForm: React.FC<IFormProps> = ({
  setCreateMode,
  paymentSubmit,
  setPaymentSubmit,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [, setErrorMessage] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  //eslint-disable-next-line no-undef
  const RETURN_URL = `${process.env.REACT_APP_ROOT_URL}/profile`;

  const confirmSetupIntent = async (event: any) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return null;
    }
    const setup = await stripe.confirmSetup({
      elements: elements,
      redirect: 'if_required',
      confirmParams: {
        return_url: RETURN_URL,
      },
    });
    if (setup?.error) {
      setErrorMessage(setup.error.message);
    }
    const setupIntentObj = {
      id: setup?.setupIntent?.id,
    };
    const confirmPayment = await PaymentsAPI.confirmSetupIntent(setupIntentObj);
    if (confirmPayment?.success) {
      if (paymentSubmit !== undefined) {
        setPaymentSubmit(
          confirmPayment.result.invoice_settings.default_payment_method,
        );
        setCreateMode(false);
        enqueueSnackbar('Successfully added new payment method', {
          variant: 'success',
        });
      } else {
        history.go();
      }
      return confirmPayment?.result;
    }
    enqueueSnackbar(
      'Failed to add new payment method. Payment details may be invalid or unacceptable',
      { variant: 'error' },
    );
  };

  return (
    <>
      <div className='add-method-modal-body-form'>
        <PaymentElement />
      </div>
      <div className='add-method-modal-footer'>
        <div className='add-method-modal-actions'>
          <div
            className='add-method-modal-cancel'
            onClick={() => setCreateMode(false)}
          >
            <div className='add-method-modal-cancel-text'>Cancel</div>
          </div>
          <div
            className='add-method-modal-submit'
            onClick={(e) => confirmSetupIntent(e)}
          >
            <div className='add-method-modal-submit-text'>Add Payment</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentForm;
